export default "__VITE_ASSET__CXgaQejq__"